const TargetGaugeConfig = ({ value = 0, amount = 0 }) => {
  const TOTAL_SEGMENTS = 15;
  const filled = Math.round((value / 100) * TOTAL_SEGMENTS);

  const series = Array.from({ length: TOTAL_SEGMENTS }, (_, i) => {
    const isFilled = i < filled;

    return {
      type: "gauge",
      startAngle: 180 - (180 / TOTAL_SEGMENTS) * i,
      endAngle: 180 - (180 / TOTAL_SEGMENTS) * (i + 1) + 3,
      radius: "100%",
      center: ["50%", "50%"],
      axisLine: {
        lineStyle: {
          width: 30,
          cap: "round",
          color: [
            [
              1,
              isFilled
                ? {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    { offset: 0, color: "rgba(124, 58, 237, 1)" },
                    { offset: 1, color: "rgba(167, 139, 250, 1)" }
                  ]
                }
                : "rgba(226, 232, 240, 0.6)"
            ]
          ]
        }
      },
      pointer: { show: false },
      axisTick: { show: false },
      splitLine: { show: false },
      axisLabel: { show: false },
      progress: { show: false },
      detail: { show: false }
    };
  });

  return {
    series,
    graphic: [
      {
        type: "text",
        left: "center",
        top: "58%", // adjust text position
        style: {
          text: `$${amount.toLocaleString()}`,
          fontSize: 14,
          fill: "#777",
          fontWeight: 500,
          textAlign: "center"
        }
      },
      {
        type: "text",
        left: "center",
        top: "70%",
        style: {
          text: `${value}% Target Achieved`,
          fontSize: 12,
          fill: "#4B5563",
          textAlign: "center"
        }
      }
    ]
  };
};

export default TargetGaugeConfig;
